import { useEffect, useState } from "react";
import { fetchSettings } from "../lib/api";

/**
 * Returns the saved bus-depot location (lat/lng/address) or null.
 * Used by route bookending UIs across the app.
 */
export function useDepot() {
  const [depot, setDepot] = useState(null);
  useEffect(() => {
    let cancelled = false;
    fetchSettings()
      .then((s) => {
        if (cancelled) return;
        if (
          typeof s?.bus_depot_latitude === "number" &&
          typeof s?.bus_depot_longitude === "number"
        ) {
          setDepot({
            latitude: s.bus_depot_latitude,
            longitude: s.bus_depot_longitude,
            address: s.bus_depot_address || "",
          });
        } else {
          setDepot(null);
        }
      })
      .catch(() => setDepot(null));
    return () => {
      cancelled = true;
    };
  }, []);
  return depot;
}
